export default "__VITE_ASSET__faba3951__"